import request from "../web-sh/src/utils/request";
import global from "../config/global";

async function get_members(params = {}) {
  return request({
    url: global.endpoint.FAMILY_MEMBERS,
    method: "get",
    params
  });
}

async function invite_members(data = {}) {
  return request({
    url: global.endpoint.FAMILY_MEMBERS,
    method: "post",
    data
  });
}

async function delete_member(id) {
  return request({
    url: global.endpoint.FAMILY_MEMBER.replace(':id', id),
    method: "delete",
  });
}


export default {
  get_members,
  invite_members,
  delete_member,
};
